"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[38450],{

/***/ 238450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MiniTerminalPicker": function() { return /* binding */ MiniTerminalPicker; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(348855);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(212808);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(408797);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(966212);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(319027);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(855271);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(634655);
/* harmony import */ var _TerminalPickerItem__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(664638);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(385365);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(684443);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  background-color: #fff;\n  padding: 1rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);\n  width: 384px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #0000000f;\n  margin-bottom: 16px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  max-height: 35vh;\n  overflow-y: auto;\n  ::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n  }\n\n  ::-webkit-scrollbar {\n    width: 6px;\n    background-color: #f5f5f5;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background-color: #999;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 14px;\n  font-weight: 500;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 12px;\n  font-weight: 400;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}








const MiniTerminalPicker = ()=>{
    const { colors  } = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .useTheme */ .F)();
    const { onOpenTerminalPicker , isGetCurrentLocation , locationGetDistanceTerminals , currentTerminals =[] , currentTerminal , setNewTerminal , setIsModeEnterAddress ,  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useDistanceTerminalContext */ .d)();
    const { epicOmni1589  } = (0,contexts__WEBPACK_IMPORTED_MODULE_4__/* .useTenantConfig */ .Wx)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Content, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Header, {
                    justify: "space-between",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Col */ .JX, {
                            style: {
                                width: "70%"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Row */ .X, {
                                    justify: "start",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__/* .HomeLocationColored */ .V, {
                                            size: 20
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                                            style: {
                                                marginLeft: 4
                                            },
                                            children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Khu vực giao h\xe0ng")
                                        })
                                    ]
                                }),
                                !isGetCurrentLocation && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SubTitle, {
                                    children: [
                                        locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.address,
                                        ",",
                                        " ",
                                        locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.wardName,
                                        ",",
                                        " ",
                                        !epicOmni1589 ? "".concat(locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.districtName, ",") : "",
                                        locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.provinceName
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Row */ .X, {
                            onClick: ()=>{
                                onOpenTerminalPicker === null || onOpenTerminalPicker === void 0 ? void 0 : onOpenTerminalPicker();
                                setIsModeEnterAddress === null || setIsModeEnterAddress === void 0 ? void 0 : setIsModeEnterAddress(true);
                            },
                            style: {
                                cursor: "pointer"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_9__/* .PenColored */ .$, {
                                    size: 20
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                                    style: {
                                        fontWeight: "initial",
                                        color: colors.primary,
                                        marginLeft: 8
                                    },
                                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Thay đổi")
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Body, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Title, {
                            children: [
                                currentTerminals === null || currentTerminals === void 0 ? void 0 : currentTerminals.length,
                                " si\xeau thị gần bạn:"
                            ]
                        }),
                        currentTerminals.map((item)=>{
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TerminalPickerItem__WEBPACK_IMPORTED_MODULE_10__/* .TerminalPickerItem */ .m, {
                                onClick: ()=>{
                                    return setNewTerminal === null || setNewTerminal === void 0 ? void 0 : setNewTerminal(item);
                                },
                                isChoice: (currentTerminal === null || currentTerminal === void 0 ? void 0 : currentTerminal.terminalId) === item.terminalId,
                                terminalName: item.terminalName,
                                distance: item.distance,
                                terminalAddress: item.fullAddress
                            }, item.terminalId);
                        })
                    ]
                })
            ]
        })
    });
};
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_11__/* .styled.div */ .z.div(_templateObject());
const Content = _teko_ui__WEBPACK_IMPORTED_MODULE_11__/* .styled.div */ .z.div(_templateObject1());
const Header = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_11__/* .styled */ .z)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Row */ .X)(_templateObject2());
const Body = _teko_ui__WEBPACK_IMPORTED_MODULE_11__/* .styled.div */ .z.div(_templateObject3());
const Title = _teko_ui__WEBPACK_IMPORTED_MODULE_11__/* .styled.span */ .z.span(_templateObject4());
const SubTitle = _teko_ui__WEBPACK_IMPORTED_MODULE_11__/* .styled.span */ .z.span(_templateObject5());


/***/ })

}]);